import { SubscriptionSize } from "../SubscriptionSize.js";

export const subscriptionSizeToAmountMap: Record<SubscriptionSize, number> = {
	[SubscriptionSize.G250]: 1,
	[SubscriptionSize.G250x2]: 2,
	[SubscriptionSize.Kg1]: 1,
};
